import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../services/data.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-advanced-search-category',
  templateUrl: './advanced-search-category.component.html',
  styleUrls: ['./advanced-search-category.component.scss']
})
export class AdvancedSearchCategoryComponent implements OnInit {

  @Input()
  category: string;

  @Input()
  title: string;

  @Input()
  hideAll: boolean = false;

  @Input()
  hardFilter: boolean = false;
  
  maxView: number = 10;

  public categoriesWithResults: any[] = [];
  private _serviceSubscription;

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService
  ) { }

  ngOnInit() {
    this.categoriesWithResults = this.dataSvc.searchData[this.category];
    //this.refreshCounts(); performance issue
    this.refreshCategoriesWithResults(this.category);
    this._serviceSubscription = this.dataSvc.searchAppliedEmitter.subscribe({
      next: (event: boolean) => {
        //this.refreshCounts(); performance issue
        this.refreshCategoriesWithResults(this.category);
      }
    });
  }

  refreshCounts(): Promise<void> {
    return new Promise<void>(async (resolve) => {
      this.refreshCategoriesWithResults(this.category);
      resolve()
    });
  }

  clearAll() {
    this.dataSvc.searchData[this.category].filter(x => x.value == true).forEach(item => {
      item.value = false;
    });
    this.filterChanged();
  }

  refreshCategoriesWithResults(category: string)  {
    const filter = this.dataSvc.getFiltersArrays().find(x => x.key === category);
    if (this.hardFilter) {
      for (let item of this.categoriesWithResults){
        if (item.hardFilter !== this.hardFilter) item.hardFilter = this.hardFilter
        if (!filter.isArray)
          item.show = this.dataSvc.filteredData.some(x => x[category] === item.name);
        else 
          item.show = this.dataSvc.filteredData.some(x => x[category].includes(item.name));
      }
    } else {
      for (let item of this.categoriesWithResults){
        if (item.hardFilter !== this.hardFilter) item.hardFilter = this.hardFilter
        if (!filter.isArray)
          item.show = this.dataSvc.filteredData.some(x => x[category] === item.name);
        else 
          item.show = this.dataSvc.filteredData.some(x => x[category].includes(item.name));
      }
    }
  }

  filterChanged() {
    clearTimeout(this.dataSvc.syncTimeout);
    clearTimeout(this.dataSvc.searchTimeout);
    
    this.loadingSvc.changeLoading("data.loadFilteredSearchData", true);
    
    this.dataSvc.syncTimeout = setTimeout(() => {
      this.dataSvc.syncFilters();
      this.dataSvc.searchTimeout = setTimeout(async () => {
        await this.dataSvc.applySearch();
        this.dataSvc.syncFilters();
        setTimeout(() => {
          //this.refreshCounts(); performance issue
          this.refreshCategoriesWithResults(this.category);
          this.loadingSvc.changeLoading("data.loadFilteredSearchData.timeout", false);
        }, 500);
      }, 300);
    }, 200);
  }
}
